import classnames from 'classnames';
import React, { useState } from 'react';
import styled from 'styled-components';

import useRegisteredEvents from '../../../hooks/useRegisteredEvents';

import RefinementSelect from '../../_molecules/RefinementSelect';
import { RefinementContainer } from '@styled';
import { mediaQueries } from '../../../../../_shared-general/breakpoints';

const SearchRefinementsMembersMyMatches = () => {
    const [openMenu, setOpenMenu] = useState(null);
    const { registeredEvents } = useRegisteredEvents();
    const hasRegisteredEvents = registeredEvents && registeredEvents.length > 0;

    return (
        <div className="d-flex flex-wrap">
            {hasRegisteredEvents && (
                <RefinementContainer className={classnames({ isOpen: openMenu === 'events' })}>
                    <RefinementSelect
                        attribute="events"
                        placeholder="Registered Events"
                        limit={1000}
                        transformItems={items =>
                            items
                                .filter(item => {
                                    const code = item.label;
                                    return !!registeredEvents.find(registered => registered.code === code);
                                })
                                .map(item => {
                                    const eventMatch = registeredEvents.find(
                                        registered => registered.code === item.label
                                    );

                                    return {
                                        ...item,
                                        label: eventMatch ? eventMatch.title : item.label,
                                    };
                                })
                        }
                        customOptionTransform={values =>
                            values.map(value => {
                                const eventMatch = registeredEvents.find(registered => registered.code === value);
                                return eventMatch ? eventMatch.title : value;
                            })
                        }
                        onMenuOpen={() => {
                            setOpenMenu('events');
                        }}
                    />
                </RefinementContainer>
            )}
        </div>
    );
};

export default SearchRefinementsMembersMyMatches;
